import Crud from '../views/Reasons/Crud'
import Entity from '../views/Reasons/Add'

let routes = {
    path: '/reasons',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/reasons/add',
            name: 'NewReasons',
            component: Entity,
            meta: {
                pageTitle: 'Motivos',
                breadcrumb: [
                    {
                        text: 'Adicionar Motivo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/reasons/edit/:id?',
            name: 'EditReasons',
            component: Entity,
            meta: {
                pageTitle: 'Motivos',
                breadcrumb: [
                    {
                        text: 'Editar Motivo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/reasons',
            name: 'list-reasons',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Motivos',
                breadcrumb: [
                    {
                        text: 'Motivos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
